import React, { Component } from 'react';
import { Element, animateScroll as scroll, scroller } from 'react-scroll';

// Utils.
import { getObjectValuesFromArray } from '../../utils';
import calculateResultsData from '../../utils/calculateResultsData';
import calculateChartData from '../../utils/calculateChartData';

// Config.
import { fields, theme } from '../../config';

// Components.
import Chart from '../../components/Chart';
import Form from '../../components/Form';
import Grid, { Row, Col } from '../../components/Grid';
import H1 from '../../components/H1';
import H2 from '../../components/H2';
import P from '../../components/P';
import Results from '../../components/Results';
import Sup from '../../components/Sup';

//------------------------------------------------------------------------------

class App extends Component {
  constructor() {
    super();

    // Bind class methods to 'this' keyword.
    this.onSubmitHandler = this.onSubmitHandler.bind(this);

    // Set initial state.
    const data = getObjectValuesFromArray(fields, 'value');
    this.state = { data };
  }

  componentDidMount() {
    scroll.scrollToTop({ duration: 600, smooth: true });
  }

  onSubmitHandler(data) {
    this.setState({ data }, () => {
      scroller.scrollTo('results', {
        duration: 600,
        smooth: true,
        offset: -14,
      });
    });
  }

  render() {
    // Destructuring state.
    const { data } = this.state;

    // Calculate data.
    const resultsData = calculateResultsData(data);
    const chartData = calculateChartData(data);

    // Default render.
    return (
      <Grid gutter={theme.gutter}>
        <Row gutter={theme.gutter}>
          <Col gutter={theme.gutter} className="Col-a">
            <H1>My Pre-Tax Contribution</H1>
            <Form fields={fields} onSubmit={this.onSubmitHandler} />
            <P small>
              Does not include salary increases or state or local taxes. See
              disclosure for full details.
            </P>
          </Col>
          <Col gutter={theme.gutter} className="Col-b">
            <Row gutter={theme.gutter}>
              <Col gutter={theme.gutter} className="Col-b__a">
                <Element name="results">
                  <H2>Results</H2>
                </Element>
                <Results title="Effect on my paycheck" data={resultsData} />
              </Col>
              <Col gutter={theme.gutter} className="Col-b__b">
                <H2>
                  My Savings Over Time<Sup>1</Sup>
                </H2>
                <Chart {...chartData} />
                <P small>
                  <Sup>1</Sup>This calculation assumes that retirement plan
                  contributions are deducted from each paycheck before federal
                  taxes. This chart is hypothetical and for illustrative
                  purposes only and is not intended to be a projection of future
                  values of any product. Investments are subject to market risk
                  and fluctuate in value.
                </P>
              </Col>
            </Row>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/index.js